<template>
  <div class="viewport viewport-with-top-nav viewport-compact">
    <TopNav></TopNav>
    <div class="display-1 my-3">{{ $t('PromotionRedirectPage.title') }}</div>
    <div class="d-flex flex-column text-center align-items-center justify-content-center">
      <div v-if="promotion.imgUrl" class="card card-rounded card-shadow border-0 mb-3 card-bg-media">
        <img :src="promotion.imgUrl" class="card-img-top" :alt="promotion.title">
      </div>
      <h3 class="mb-4">{{ promotion.title }}</h3>
      <p class="text-muted-more">{{ promotion.excerpt }}</p>
    </div>
    <div class="flex-grow-1"></div>
    <a :href="promotion.link" target="_blank"
       class="btn btn-lg btn-primary btn-block mt-3">{{ $t('PromotionRedirectPage.openWebsite') }}</a>
  </div>
</template>

<script>
import TopNav from '@shared/components/TopNav'
import store from '@shared/store'

export default {
  name: 'PromotionRedirectPage',
  components: { TopNav },
  data() {
    return {
      promotion: store.getBuffer()
    }
  }
}
</script>
